import CONSTANTS from '../constants';
import {_createStatePessoa} from '../modules/api';




let state = {
    valueAbaIndex: window.__token_tokenFiador__ ? 1 : 0, //__token_tokenFiador__ é setado na View.cshtml // 1->fiadores 0->solicitacao
    globalError: "",
    listTpMoradia: [],
    listNacionalidade: [],
    solicitacao: {
        progressoFinalizar: '',
        alteracao: {
            pesCPF: "",
            carregando: false
        },
        isAlteracao: false,
        msgSucesso: "",
        solSeq: -1,
        aceite: false,
        aceiteRegulamento: false,
        finalizando: false,
        captcha: "",
        activeStep: 0,
        cursoInteresse: {
            perSeq: 0,
            erro: "",
            carregando: false,
            listAllFinanciamentos: [],
            listCursos: [],
            listPeriodo: [],
            listPolo: [],
            curCodigo: 0,
            curURL: "",
            perPeriodo: 0,
            polCodigo: 0,
            maximoPercent: 0,
            solPercentual: 0,
            solMotivo: " ",
            perDtFim: ''
        },
        dadosInteressado: {
            listEstados: ["AC", "AL", "AM", "AP", "BA", "CE", "DF",
                "ES", "GO", "MA", "MG", "MS", "MT", "PA", "PB",
                "PE", "PI", "PR", "RJ", "RN", "RO", "RR",
                "RS", "SC", "SE", "SP", "TO"],
            uf: "",
            nacCodigo: 1,
            carregandoCidades: false,
            carregandoCEP: false,
            locCodigo: "",
            cidadeCEP: "",
            cpfOK: false,
            pesNro: "",
            permissaoAlterar: -1,
            carregandoPessoaCPF: false,
            pesCPF: "",
            pesNome: "",
            emlEmail: "",
            pesDtNasc: "",
            pesRG: "",
            pesEstExp: "",
            pesOrgExp: "",
            pesTelefone: "",
            pesCelular: "",
            possuiAlgumaDeficiencia: "N",
            pesBairro: "",
            tdfCodigo: 0, //deficiencia    
            listDeficiencias: [/* {TdfCodigo ,TdfDescricao^} */],
            pesCEP: "",
            pesRua: "",
            listCidades: [],
            pesEmpresa: "",
            pesDtAdmissao: "",
            pesCargo: "",
            pesRendaBruta: "",
            solAnoConcl2g: "",
            solRede2g: "",
            solEnem: "",
            solAnoEnem: "",
            solPontEnem: "",
            solCursoSup: "",
            solNomeCursoSup: "",
            pesEstCiv: "",
            pesSexo: '0',
            /**conjuge */
            conjugePesSexo: '0',
            conjugePermissaoAlterar: -1,
            conjuge_carregandoPessoaCPF: false,
            conjuge_cpfOK: false,
            conjugePesCPF: "",
            conjugePesNro: "",
            conjugePesNome: "",
            conjugePesDtNasc: "",
            conjugePesRG: "",
            conjugePesEstExp: "",
            conjugePesOrgExp: "",
            conjugePesTelefone: "",
            conjugePesCelular: "",
            conjugePesEmpresa: "",
            conjugePesCargo: "",
            conjugePesRendaBruta: "",
            conjugePesDtAdmissao: "",
            conjugeNacCodigo: 1,
            campoErros: {
            }
        },
        grupoFamiliar: {
            listArquivosGrupoFamiliar: [],
            solTpMoradia: "",
            listFamiliar: [],
            listTpMoradia: [],
            listParentesco: [],
            itemFamiliar: {
                famNome: "",
                famIdade: "",
                famCpf: "",
                famParentesco: "",
                famEscolaridade: "",
                famProfissao: "",
                famRendaBruta: ""
            }
        }
    },
    fiadores: {  
        progressoFinalizarFiador: "",
        concluindo: false,      
        listArquivos: [],
        listArquivosSeq: [],
        envioDeFiadoresConcluidoComSucesso: "",
        indexAbaFiador: 0,
        carregandoForm: false,
        dadosResponsavel: _createStatePessoa(CONSTANTS._TIPO_PESSOA.RESPONSAVEL),
        dadosSolicitacao: {
            solSeq: 0,
            maiorDeIdade: false,
            pesCPF: '',
            pesNome: ''
        },
        listFiadores: []     
    }
};



export default state;


// WEBPACK FOOTER //
// ./src/state/index.js